/* imods-repair-status.js — the Repair status page (sections/imods-repair-status.liquid; tracker build session 1, 2026-11-04,
   clean_bench/tracker_build_20261103/BUILD_SPEC_THEME.md). Enhancements only: without it the page explains the steps and how to
   reach us. It talks to the iMods Repair Tracker through Shopify's app proxy (same origin; data-rs-api = /apps/repair):
     GET  status?t=<link token>                 -> the full view (full tracking numbers, Track buttons)
     POST lookup   { order, email, turnstile }  -> the limited view (last 4 digits, no Track button) + a lookup session
     POST tracking { t | session, number }      -> the updated view
     POST approve  { t | session }              -> the updated view (TRK-14: the customer's "Yes, repair it"; once per quote)
   An answer is { ok: false, message } (the message is shown as is) or a view. Two spellings of a view are read (norm below): the
   theme spec's contract { view, order, kind, stage, steps: [{ key, label, state, date, note }], headline, text, move: { who, title,
   text }, tracking: [{ leg, carrier, number | last4, trackUrl }], history: [{ at, text }], canAddTracking } and the tracker's own
   (worker/src/view.js): body for text, badge, move.yours, steps[].who / at / atLabel, legs[] with label / numberDisplay / status,
   history[].atLabel, service, model, session. Server words only ever go in as text, never as HTML; a Track button only links to
   the three carriers' own tracking pages, and never in the limited view. Read from the address bar: t (the e-mail link) and order
   (prefill only, the work order's rule R1a). The e-mail typed into the lookup is sent once, then cleared; nothing is stored.
   Turnstile's script loads only when the lookup form shows and the section has a site key. The words: data-rs-copy.
   The quote (TRK-14, owner §340-§341): when the view carries `quote` (amount + his note) it shows in BOTH views, so it is there
   even when e-mail fails, with ONE button, "Yes, repair it" (canApprove), or, once approved, the tracker's confirmation line.
   His note is text only (never HTML); his line breaks stay. No decline button: a "no" is a reply to the quote e-mail. */
(function () {
  'use strict';
  function boot(root) {
    if (!root || root.getAttribute('data-rs-ready') === '1') return;
    root.setAttribute('data-rs-ready', '1');
    function $(s, r) { return (r || root).querySelector(s); }
    function str(v) { return v == null ? '' : String(v); }
    var C = {};
    try { C = JSON.parse(str(($('[data-rs-copy]') || {}).textContent) || '{}'); } catch (e) { C = {}; }
    function w(path, dflt) {
      var v = C;
      path.split('.').forEach(function (k) { v = v && typeof v === 'object' ? v[k] : undefined; });
      return typeof v === 'string' ? v : dflt;
    }
    function fill(s, o) { return str(s).replace(/\{(\w+)\}/g, function (m, k) { return o[k] != null ? o[k] : m; }); }

    var API = str(root.getAttribute('data-rs-api') || '/apps/repair').replace(/\/+$/, '');
    var KEY = str(root.getAttribute('data-rs-key')).trim();
    var MAIL = str(root.getAttribute('data-rs-mail')).trim() || 'sales@imods.com';
    var TZ = w('tz', 'America/New_York');   // the shop's clock, as the tracker's own e-mails and texts write times
    var params = new URLSearchParams(location.search);
    var T = str(params.get('t')).trim();
    var session = '';
    var ui = {
      intro: $('[data-rs-intro]'), meta: $('[data-rs-meta]'), say: $('[data-rs-say]'), main: $('.rs-main'),
      note: $('[data-rs-note]'), noteText: $('[data-rs-note-text]'),
      view: $('[data-rs-view]'), lookup: $('[data-rs-lookup]'), how: $('[data-rs-how]'), history: $('[data-rs-history]'),
      hist: $('[data-rs-hist]'), where: $('[data-rs-where]'), orderRef: $('[data-rs-orderref]'), mailto: $('[data-rs-mailto]'),
      addTpl: $('[data-rs-add-tpl]')
    };

    /* ---------- small helpers ---------- */
    function el(tag, attrs, kids) {
      var n = document.createElement(tag);
      Object.keys(attrs || {}).forEach(function (k) {
        var v = attrs[k];
        if (v == null || v === false) return;
        if (k === 'text') n.textContent = v;
        else if (k === 'class') n.className = v;
        else n.setAttribute(k, v);
      });
      (kids || []).forEach(function (c) { if (c != null && c !== '') n.appendChild(typeof c === 'string' ? document.createTextNode(c) : c); });
      return n;
    }
    function show(n, on) { if (n) n.hidden = !on; }
    var SVG = 'http://www.w3.org/2000/svg';
    function icon(id) {
      var s = document.createElementNS(SVG, 'svg'), u = document.createElementNS(SVG, 'use');
      s.setAttribute('class', 'i'); s.setAttribute('aria-hidden', 'true'); s.setAttribute('focusable', 'false');
      u.setAttribute('href', '#' + id); s.appendChild(u);
      return s;
    }
    function say(msg) {
      if (!ui.say) return;
      ui.say.textContent = '';
      setTimeout(function () { ui.say.textContent = msg; }, 60);
    }
    function setErr(form, msg) { var n = form && form.querySelector('[data-rs-err]'); if (n) n.textContent = msg || ''; }
    function note(msg) { if (ui.noteText) ui.noteText.textContent = msg || ''; show(ui.note, !!msg); }
    function invalid(input, bad, errId) {
      if (!input) return;
      if (bad) { input.setAttribute('aria-invalid', 'true'); if (errId) input.setAttribute('aria-describedby', errId); }
      else { input.removeAttribute('aria-invalid'); if (errId && input.getAttribute('aria-describedby') === errId) input.removeAttribute('aria-describedby'); }
    }
    function busy(btn, on) { if (!btn) return; btn.disabled = !!on; btn.setAttribute('aria-busy', on ? 'true' : 'false'); }
    function loading(on) {
      root.classList.toggle('rs--loading', !!on);
      if (ui.main) ui.main.setAttribute('aria-busy', on ? 'true' : 'false');
      if (!on) document.documentElement.classList.remove('rs-pending');
    }
    function netErr() {
      return fill(w('errNet', "We couldn't reach our repair tracker just now. Try again in a minute, or e-mail {email} with your order number."), { email: MAIL });
    }

    /* ---------- the tracker's API (same origin, JSON both ways) ---------- */
    function api(method, path, body) {
      var ctl = typeof AbortController === 'function' ? new AbortController() : null;
      var timer = ctl ? setTimeout(function () { ctl.abort(); }, 20000) : null;
      var opt = { method: method, credentials: 'same-origin', headers: { Accept: 'application/json' } };
      if (ctl) opt.signal = ctl.signal;
      if (body) { opt.headers['Content-Type'] = 'application/json'; opt.body = JSON.stringify(body); }
      return fetch(API + '/' + path, opt)
        .then(function (r) { return r.json().catch(function () { return null; }); })
        .catch(function () { return null; })
        .then(function (d) {
          if (timer) clearTimeout(timer);
          if (d && typeof d === 'object' && d.ok === true) return d;
          if (d && typeof d === 'object' && d.ok === false && str(d.message).trim()) return { ok: false, message: str(d.message) };
          return { ok: false, message: netErr(), net: true };
        });
    }

    /* ---------- formatting ---------- */
    var THIS_YEAR = new Date().getFullYear();
    function when(s) {
      s = str(s).trim();
      if (!s) return '';
      var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s), d = null, o = null;
      if (m) { d = new Date(+m[1], +m[2] - 1, +m[3]); o = { weekday: 'short', month: 'short', day: 'numeric' }; }   // a calendar day: no clock
      else if (/^\d{4}-\d{2}-\d{2}T/.test(s)) { d = new Date(s); o = { weekday: 'short', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit', timeZone: TZ }; }
      if (!d || isNaN(d.getTime())) return s;   // already in words: shown as sent
      if (d.getFullYear() !== THIS_YEAR) o.year = 'numeric';
      try { return d.toLocaleString('en-US', o).replace(/ /g, ' '); } catch (e) { return s; }
    }
    function isoOf(s) { s = str(s).trim(); return /^\d{4}-\d{2}-\d{2}/.test(s) ? s : null; }
    function trackNum(n) { n = str(n).replace(/\s+/g, '').toUpperCase(); return /^\d+$/.test(n) ? n.replace(/(\d{4})(?=\d)/g, '$1 ') : n; }
    function orderText(o) { o = str(o).trim(); return o ? (o.charAt(0) === '#' ? o : '#' + o) : ''; }
    var TRACK_OK = /^https:\/\/(tools\.usps\.com|www\.ups\.com|www\.fedex\.com)\//;

    /* ---------- one shape for both spellings of a view (see the header) ---------- */
    function list(a) { return Array.isArray(a) ? a.filter(function (x) { return x && typeof x === 'object'; }) : []; }
    function norm(d) {
      var mv = d.move && typeof d.move === 'object' ? d.move : {};
      return {
        view: d.view === 'full' ? 'full' : 'limited',
        order: orderText(d.order), model: str(d.model).trim(), stage: str(d.stage), session: str(d.session).trim(), kind: str(d.kind),
        kindText: w('kinds.' + str(d.kind), '') || str(d.service).trim(),
        badge: str(d.badge).trim(), headline: str(d.headline).trim(), text: str(d.text != null ? d.text : d.body).trim(),
        move: { you: mv.who === 'you' || mv.yours === true, title: str(mv.title).trim(), text: str(mv.text).trim() },
        steps: list(d.steps).filter(function (s) { return str(s.label).trim(); }).map(function (s) {
          return { key: str(s.key), label: str(s.label).trim(), state: s.state, who: str(s.who).trim(), note: str(s.note).trim(),
            at: s.date != null ? s.date : s.at, atLabel: str(s.atLabel).trim() };
        }),
        legs: list(Array.isArray(d.tracking) ? d.tracking : d.legs).map(function (x) {
          return { leg: str(x.leg), label: str(x.label).trim(), carrier: str(x.carrier).trim(), number: str(x.number).trim(),
            numberDisplay: str(x.numberDisplay).trim(), last4: str(x.last4).trim(), trackUrl: str(x.trackUrl).trim(), status: str(x.status).trim() };
        }),
        history: list(d.history).filter(function (h) { return str(h.text).trim(); }).map(function (h) {
          return { at: h.at, atLabel: str(h.atLabel).trim(), text: str(h.text).trim() };
        }),
        canAdd: d.canAddTracking === true,
        quote: quoteOf(d.quote),
        canApprove: d.canApprove === true
      };
    }
    function quoteOf(q) {
      if (!q || typeof q !== 'object' || !str(q.amount).trim()) return null;
      return { amount: str(q.amount).trim(), note: str(q.note).replace(/\r\n?/g, '\n').trim(), approved: q.approved === true,
        text: str(q.text).trim(), approvedLabel: str(q.approvedLabel).trim() };
    }

    /* ---------- who moves each step, when the server does not say ---------- */
    var US = ['on_bench', 'quote_sent', 'approved', 'repairing', 'shipped_back', 'declined', 'kit_shipped', 'closed'];
    function carrierOn(v, legs) {
      var x = v.legs.filter(function (t) { return legs.indexOf(t.leg) >= 0 && t.carrier; })[0];
      return x ? x.carrier : '';
    }
    function whoOf(s, v) {
      if (s.who) return s.who;
      var k = s.key, carrier = w('who.carrier', 'Carrier');
      if (k === 'tracking_added' || k === 'ordered') return w('who.you', 'You');
      if (US.indexOf(k) >= 0) return w('who.us', 'iMods');
      if (k === 'in_transit' || k === 'delivered_to_imods') return carrierOn(v, ['inbound', 'kit_inbound']) || carrier;
      if (k === 'delivered_home') return carrierOn(v, ['return']) || w('who.return', carrier);   // the site: "Your iPod ships back by USPS"
      if (k === 'kit_delivered') return carrierOn(v, ['kit', 'kit_outbound']) || carrier;
      return '';
    }

    /* ---------- the page's own lines (BUILD_SPEC_THEME "Copy"), only where they are true and the server's words don't say it yet:
       the bench line when this repair has a quote step, the decline line on a free diagnostic's quote, the warranty line once a repair
       was done (never after a declined quote) ---------- */
    function pageLine(v) {
      var k = v.stage, key = '', mark = '';
      function has(key, st) { return v.steps.some(function (s) { return s.key === key && (!st || s.state === st); }); }
      if (k === 'on_bench' && has('quote_sent')) { key = 'bench'; mark = 'quote'; }
      else if (k === 'quote_sent' && /^dx_/.test(v.kind)) { key = 'decline'; mark = 'decline'; }
      else if ((k === 'shipped_back' || k === 'delivered_home') && has('repairing', 'done') && !has('declined')) { key = 'warranty'; mark = 'warranty'; }
      var line = key ? w('lines.' + key, '') : '';
      if (!line) return '';
      return [v.headline, v.text, v.move.title, v.move.text].join(' ').toLowerCase().indexOf(mark) >= 0 ? '' : line;
    }

    /* ---------- the view ---------- */
    function stepList(v) {
      if (!v.steps.length) return null;
      var ol = el('ol', { class: 'rs-steps', role: 'list', 'aria-label': w('stepsLabel', 'Repair steps') }), current = false;
      v.steps.forEach(function (s, i) {
        var st = s.state === 'done' ? 'done' : (s.state === 'now' && !current) ? 'now' : 'next';
        if (st === 'now') current = true;
        var mark = el('span', { class: 'rs-mark', 'aria-hidden': 'true' });
        if (st === 'done') mark.appendChild(icon('cbi-check')); else mark.textContent = String(i + 1);
        var detail = el('span', { class: 'rs-detail' }, [el('span', { class: 'rs-state', text: w('state.' + st, st === 'done' ? 'Done' : st === 'now' ? 'Now' : 'Next') })]);
        var at = st === 'next' ? '' : (s.atLabel || when(s.at)), iso = isoOf(s.at);
        if (at) { detail.appendChild(document.createTextNode(' · ')); detail.appendChild(iso ? el('time', { datetime: iso, text: at }) : document.createTextNode(at)); }
        if (s.note) detail.appendChild(document.createTextNode(' · ' + s.note));
        var who = whoOf(s, v);
        // (the ' ' between the parts keeps the words apart in copied text and reading modes; grid layout ignores it)
        ol.appendChild(el('li', { class: 'is-' + st, 'aria-current': st === 'now' ? 'step' : null }, [mark,
          el('div', { class: 'rs-st' }, [who ? el('span', { class: 'rs-who', text: who }) : null, ' ', el('span', { class: 'rs-title', text: s.label }), ' ', detail])]));
      });
      return ol;
    }
    function trackRows(v) {
      var limited = v.view !== 'full';
      var rows = v.legs.filter(function (x) { return x.number || x.last4; });
      if (!rows.length) return null;
      var ul = el('ul', { class: 'rs-trks', role: 'list' });
      rows.forEach(function (x) {
        var leg = [x.label || w('legs.' + x.leg, ''), x.status].filter(Boolean).join(' · '), full = !limited && x.number, txt;
        if (full) txt = (x.carrier ? x.carrier + ' ' : '') + (x.numberDisplay || trackNum(x.number));
        else txt = fill(w('ending', '{carrier} number ending in {last4}'), { carrier: x.carrier || 'Tracking', last4: (x.last4 || x.number).slice(-4) });
        var li = el('li', { class: 'rs-trk' }, [el('span', { class: 'rs-trk-info' }, [leg ? el('span', { class: 'rs-leg', text: leg }) : null, ' ',
          el('span', { class: full ? 'rs-num mono' : 'rs-num', text: txt })])]);
        if (full && TRACK_OK.test(x.trackUrl)) {
          li.appendChild(document.createTextNode(' '));
          li.appendChild(el('a', { class: 'btn btn-secondary', href: x.trackUrl, target: '_blank', rel: 'noopener noreferrer' },
            [fill(w('track', 'Track on {carrier}'), { carrier: x.carrier || 'the carrier' }), el('span', { class: 'cb-vh', text: ' ' + w('newTab', '(opens in a new tab)') })]));
        }
        ul.appendChild(li);
      });
      return ul;
    }
    /* ---------- the quote: amount, his note, "Yes, repair it" (or the confirmation once approved) ---------- */
    function quoteBlock(v) {
      var q = v.quote, box = el('div', { class: 'rs-quote', role: 'group', 'aria-label': w('quote.label', 'Repair quote') });
      box.appendChild(el('p', { class: 'rs-quote-head' }, [el('span', { class: 'eyebrow', text: w('quote.label', 'Repair quote') }), ' ',
        el('span', { class: 'rs-quote-amount', text: q.amount })]));
      // paragraphs between blank lines; single line breaks stay inside a paragraph (white-space: pre-line)
      q.note.split(/\n{2,}/).forEach(function (p) { if (p.trim()) box.appendChild(el('p', { class: 'rs-quote-note', text: p.trim() })); });
      if (q.approved) {
        var yes = q.text || fill(w('quote.approved', "You approved the repair on {date}. We'll e-mail your PayPal invoice."), { date: q.approvedLabel });
        box.appendChild(el('p', { class: 'note ok rs-quote-done' }, [icon('cbi-check'), el('span', { text: yes })]));
      } else if (v.canApprove && (T || session)) {
        var btn = el('button', { class: 'btn btn-primary', type: 'button', 'aria-busy': 'false', text: w('quote.button', 'Yes, repair it') });
        btn.addEventListener('click', onApprove);
        box.appendChild(el('div', { class: 'btn-row' }, [btn]));
        box.appendChild(el('span', { class: 'rs-err', role: 'alert', 'data-rs-err': '' }));
      } else {
        box.appendChild(el('p', { class: 'hint', text: w('quote.noButton', 'To go ahead, reply to our quote e-mail with yes.') }));
      }
      return box;
    }
    function addForm() {
      var tpl = ui.addTpl, f = tpl && tpl.content && tpl.content.firstElementChild;
      if (!f) return null;
      f = f.cloneNode(true);
      f.addEventListener('submit', onAdd);
      return f;
    }
    function card(v) {
      var now = v.steps.filter(function (s) { return s.state === 'now'; })[0];
      var badge = v.badge || (v.move.you ? w('yourMove', 'Your move') : (now ? now.label : ''));
      var good = v.stage === 'shipped_back' || v.stage === 'delivered_home' || !!(v.quote && v.quote.approved);
      var box = el('div', { class: 'card pad rs-hero rs-in' });
      if (badge) box.appendChild(el('span', { class: 'badge rs-badge ' + (v.move.you ? 'b-ink' : good ? 'b-ok' : 'b-info'), text: badge }));
      box.appendChild(el('h2', { class: 'rs-headline', tabindex: '-1', text: v.headline || badge || w('order', 'Order') + ' ' + v.order }));
      if (v.text) box.appendChild(el('p', { class: 'rs-text', text: v.text }));
      var line = pageLine(v);
      if (line) box.appendChild(el('p', { class: 'rs-text', text: line }));
      var mvTitle = v.move.title;
      if (mvTitle && mvTitle.toLowerCase() === badge.toLowerCase()) mvTitle = '';   // the badge already says it ("Your move")
      if (mvTitle || v.move.text) box.appendChild(el('div', { class: 'rs-move' }, [mvTitle ? el('b', { text: mvTitle }) : null, ' ', v.move.text ? el('span', { text: v.move.text }) : null]));
      if (v.quote) box.appendChild(quoteBlock(v));
      var rows = trackRows(v);
      if (rows) {
        box.appendChild(rows);
        if (v.view !== 'full') box.appendChild(el('p', { class: 'hint', text: w('limited', '') }));
      }
      if (v.canAdd && (T || session)) { var f = addForm(); if (f) box.appendChild(f); }
      return box;
    }
    function render(d) {
      var v = norm(d);
      if (v.view !== 'full' && v.session) session = v.session;
      ui.meta.textContent = '';
      if (v.order) ui.meta.appendChild(el('span', { class: 'im-plate', text: w('order', 'Order') + ' ' + v.order }));
      var line = [v.model, v.kindText].filter(Boolean).join(' · ');
      if (line) { if (v.order) ui.meta.appendChild(document.createTextNode(' ')); ui.meta.appendChild(el('span', { text: line })); }
      show(ui.meta, !!(v.order || line));
      show(ui.intro, false);
      ui.view.textContent = '';
      ui.view.appendChild(card(v));
      var ol = stepList(v);
      if (ol) ui.view.appendChild(ol);
      show(ui.view, true); show(ui.lookup, false); show(ui.how, false); show(ui.where, false); note('');
      ui.hist.textContent = '';
      v.history.forEach(function (h) {
        var at = h.atLabel || when(h.at), iso = isoOf(h.at);
        ui.hist.appendChild(el('li', null, [at ? el('time', { datetime: iso, text: at }) : null, ' ', el('span', { text: h.text })]));
      });
      show(ui.history, ui.hist.children.length > 0);
      if (v.order) {
        if (ui.orderRef) ui.orderRef.textContent = fill(w('orderRef', 'order {order}'), { order: v.order });
        if (ui.mailto) ui.mailto.setAttribute('href', 'mailto:' + MAIL + '?subject=' + encodeURIComponent(w('order', 'Order') + ' ' + v.order));
      }
      loading(false);
    }
    function focusHead() {
      var h = ui.view.querySelector('.rs-headline');
      if (!h) return;
      // Chromium centers an off-screen element on focus() (clean-bench trap #155): scroll it to the top first, then focus in place
      var top = h.getBoundingClientRect().top;
      if (top < 0 || top > window.innerHeight * 0.5) h.scrollIntoView({ block: 'start' });
      try { h.focus({ preventScroll: true }); } catch (e) { h.focus(); }
    }

    /* ---------- the e-mail link (?t=) ---------- */
    function getStatus(focus) {
      show(ui.how, false);   // from here on the script decides (the section's 8-second fallback would bring the explainer back)
      loading(true);
      api('GET', 'status?t=' + encodeURIComponent(T)).then(function (d) {
        if (!d.ok) { showLookup(''); note(d.message); return; }   // a link problem: above the lookup, not as a field error
        render(d);
        if (focus) focusHead();
      });
    }

    /* ---------- the lookup (order number + e-mail), with Turnstile when a site key is set ---------- */
    var ts = { id: null, state: '' };
    function loadTurnstile() {
      var box = ui.lookup && ui.lookup.querySelector('[data-rs-ts]');
      if (!KEY || !box || ts.state) return;
      ts.state = 'loading';
      show(box, true);
      function draw() {
        try {
          ts.id = window.turnstile.render(box, { sitekey: KEY, action: 'lookup', theme: 'light', size: 'flexible' });
          ts.state = 'ready';
        } catch (e) { ts.state = 'failed'; show(box, false); }
      }
      function failed() {
        ts.state = 'failed';
        show(box, false);
        setErr(ui.lookup, fill(w('errCheckLoad', "The security check didn't load. Reload the page, or e-mail {email} with your order number."), { email: MAIL }));
      }
      if (window.turnstile && typeof window.turnstile.render === 'function') { draw(); return; }
      var s = document.querySelector('script[data-rs-turnstile]');
      if (!s) {
        s = document.createElement('script');
        s.setAttribute('data-rs-turnstile', '');
        s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
        s.async = true;
        document.head.appendChild(s);
      }
      s.addEventListener('load', draw);
      s.addEventListener('error', failed);
    }
    function tsToken() { try { return ts.id != null && window.turnstile ? str(window.turnstile.getResponse(ts.id)) : ''; } catch (e) { return ''; } }
    function tsReset() { try { if (ts.id != null && window.turnstile) window.turnstile.reset(ts.id); } catch (e) {} }
    function showLookup(msg) {
      loading(false);
      show(ui.view, false); show(ui.meta, false); show(ui.history, false);
      show(ui.intro, true); show(ui.lookup, true); show(ui.how, true); show(ui.where, true);
      var oi = ui.lookup.querySelector('[name="order"]'), o = str(params.get('order')).replace(/[^0-9]/g, '').slice(0, 12);
      if (o && oi && !oi.value) oi.value = '#' + o;
      setErr(ui.lookup, msg || '');
      loadTurnstile();
    }
    function onLookup(e) {
      e.preventDefault();
      var f = ui.lookup, oi = f.querySelector('[name="order"]'), ei = f.querySelector('[name="email"]'), btn = f.querySelector('[type="submit"]');
      var order = oi.value.trim(), email = ei.value.trim();
      var badO = !/^#?\s*\d{1,12}$/.test(order), badE = !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
      invalid(oi, badO, 'rsLookErr'); invalid(ei, badE, 'rsLookErr');
      if (badO || badE) { setErr(f, w('errFields', 'Enter your order number and the e-mail you used to order.')); (badO ? oi : ei).focus(); return; }
      var tok = tsToken();
      if (KEY && ts.state !== 'failed' && !tok) { setErr(f, w('errCheck', 'Finish the security check, then try again.')); return; }
      setErr(f, ''); note('');
      busy(btn, true);
      api('POST', 'lookup', { order: order, email: email, turnstile: tok }).then(function (d) {
        busy(btn, false);
        tsReset();
        if (!d.ok) { setErr(f, d.message); return; }
        ei.value = '';
        render(d);
        focusHead();
      });
    }

    /* ---------- "Mailed it? Add your tracking number" ---------- */
    function onAdd(e) {
      e.preventDefault();
      var f = e.currentTarget, ni = f.querySelector('[name="number"]'), btn = f.querySelector('[type="submit"]');
      var num = ni.value.replace(/[\s-]+/g, '').toUpperCase();
      var bad = !/^[0-9A-Z]{8,40}$/.test(num);
      invalid(ni, bad, 'rsTrkErr');
      if (bad) { setErr(f, w('errNumber', 'Enter the tracking number from your label.')); ni.focus(); return; }
      setErr(f, '');
      busy(btn, true);
      api('POST', 'tracking', T ? { t: T, number: num } : { session: session, number: num }).then(function (d) {
        busy(btn, false);
        if (!d.ok) { setErr(f, d.message); ni.focus(); return; }
        say(w('saved', 'Tracking number saved.'));
        if (Array.isArray(d.steps)) { render(d); focusHead(); }
        else if (T) getStatus(true);
      });
    }

    /* ---------- "Yes, repair it" ---------- */
    function onApprove(e) {
      var btn = e.currentTarget, box = btn.closest('.rs-quote'), label = btn.textContent;
      if (btn.disabled) return;
      setErr(box, '');
      busy(btn, true);
      btn.textContent = w('quote.busy', 'Saving…');
      api('POST', 'approve', T ? { t: T } : { session: session }).then(function (d) {
        if (!d.ok) {
          busy(btn, false);
          btn.textContent = label;
          setErr(box, d.net ? w('quote.errNet', "We couldn't reach our repair tracker just now. Try again in a minute, or reply to our quote e-mail with yes.") : d.message);
          return;
        }
        say(w('quote.saved', 'Thanks! You approved the repair.'));
        render(d);
        focusHead();
      });
    }

    if (ui.lookup) ui.lookup.addEventListener('submit', onLookup);
    if (T) getStatus(false); else showLookup('');
  }
  boot(document.querySelector('[data-rs]'));
  // the theme editor re-renders a section after a setting changes (the Turnstile site key, the heading ...) and tells scripts only
  // through this event: start the new copy of the section, or it would show only the no-JavaScript explainer until a reload
  document.addEventListener('shopify:section:load', function (e) { boot(e.target && e.target.querySelector ? e.target.querySelector('[data-rs]') : null); });
})();
